<template>
  <v-overlay :value="_value" z-index="999999">
    <div class="d-flex flex-column align-center justify-center">
      <v-progress-circular
        :color="color"
        :size="size"
        indeterminate
      ></v-progress-circular>

      <div v-if="label" :class="textClass" class="mt-6">
        {{ label }}
      </div>

      <div v-if="labels.length" :class="textClass" class="mt-6">
        {{ labels[index] }}
      </div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: "LoaderOverlay",

  data() {
    return {
      interval: null,
      index: 0,
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    size: {
      type: [String, Number],
      default: "64",
    },

    color: {
      type: String,
      default: "primary",
    },

    label: {
      type: String,
      default: "",
    },

    labels: {
      type: Array,
      default: () => [],
    },

    textClass: {
      type: String,
      default: "neutral8--text text-body-1",
    },
  },

  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  watch: {
    _value: {
      handler(val) {
        if (!!val && this.labels.length) this.handleLabelInterval();
        if (!val) {
          clearInterval(this.interval);
          this.index = 0;
        }
      },
      immediate: true,
    },
  },

  methods: {
    handleLabelInterval() {
      this.interval = setInterval(() => {
        if (this.index === this.labels.length - 1) this.index = 0;
        else this.index++;
      }, 5000);
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
